import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { EnvService } from '../../environments/env.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  currentUser: any;
  author = '';
  url = null;
  error = '';

  constructor(
    private http: HttpClient,
    private envService: EnvService,
  ) {
    this.url = this.envService.getLoginUrl();
    const token = localStorage.getItem('token');
    if (token) {
      const jwt = new JwtHelperService();
      this.currentUser = jwt.decodeToken(token);
    }
  }

  login(credentials): Observable<boolean> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Basic ${btoa(credentials)}`,
      }),
    };
    if (this.currentUser) {
      this.logout();
    }
    return this.http
      .post<any>(this.url, null, httpOptions)
      .pipe(
        map((response) => {
          if (response && response.token) {
            localStorage.setItem('token', response.token);
            this.getAuthor();
            return true;
          }
          return false;
        }),
      )
      .pipe(catchError(this.handleError));
  }

  logout(): void {
    localStorage.removeItem('token');
    this.currentUser = null;
    this.author = '';
  }

  isLoggedIn(): boolean {
    if (this.currentUser) {
      const token = localStorage.getItem('token');
      if (new JwtHelperService().isTokenExpired(token)) {
        return false;
      }
      return true;
    }
    return false;
  }

  getAuthor() {
    const jwt = new JwtHelperService();
    this.currentUser = jwt.decodeToken(localStorage.getItem('token'));
    this.author = this.currentUser.author;
    return this.author;
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error ocurred:', error.error.message);
    } else {
      console.log('Error object:', error);
      if (error.status === 0) {
        this.error = 'Verbindung zum Server fehlgeschlagen. Bitte überprüfen Sie Ihre VPN-Verbindung.';
      } else if (error.status === 401) {
        this.error = 'Die Logindaten sind falsch.';
      } else if (error.status === 502) {
        this.error = 'Server Fehler.';
        console.error('Server error');
      } else {
        this.error = `Server Fehler (${error.status})`;
        console.error(`Backend returned code ${error.status}, message: ${error.message}`);
      }
    }

    return throwError(`Ein Fehler ist aufgetreten. ${this.error}`);
  }
}
